import { Button, ButtonSize } from "../../../../components/Button"
import { useTextStorage } from "../../../../hooks/TextStorageProvider"
import "./GallerySection.scss"
import { galleryDecor } from "../../../../assets/images"
import { useNavigate } from "react-router-dom"

export const GallerySection: React.FC = () => {
  const { ts } = useTextStorage()
  const navigate = useNavigate()

  const handleButtonClick = () => {
    navigate("/gallery")
  }
  return (
    <div className="gallery-section">
      <div className="gallery-section--content">
        <h2>{ts.pages.home.gallerySection.title}</h2>
        <p>{ts.pages.home.gallerySection.text}</p>
        <Button
          text={ts.pages.home.gallerySection.buttonText}
          size={ButtonSize.SM}
          onClick={handleButtonClick}
        />
      </div>
      <img src={galleryDecor} alt="gallery-decor" className="gallery-decor" />
    </div>
  )
}
